import React from 'react';
import { useHistory } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmBox } from '@/components/uiParts';
import { redirect404Page } from '@/lib/AccessControl';
import { routes } from '@/router';
import {
  useManagerAccountCreate,
  useManagerAccountMe,
} from '@/services/AuthEnterprise/hooks';

import { MemberInviteForm } from './components/MemberInviteForm';

const MemberInvitePage: React.FC = () => {
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  /* アクセス制御 */
  redirect404Page('manage_account', history, managerAccountMe);
  const managerAccountCreate = useManagerAccountCreate();

  return (
    <PageLayout title={routes.SettingsMemberManagementInvite.title}>
      <CmBox pt={4}>
        <MemberInviteForm onSubmit={managerAccountCreate} />
      </CmBox>
    </PageLayout>
  );
};

export default MemberInvitePage;
